import { EditableGroup } from "../types/EditableGroup";
import { scaffoldEdit } from "../../../common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "GROUP/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "GROUP/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "GROUP/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "GROUP/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "GROUP/SAVE_EDITABLE_SUCCESS",
    SAVE_FAILURE = "GROUP/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableGroup, {}, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
